import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

const OPEN_CART_DRAWER_SESSION_KEY = 'celso:open-cart-drawer';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.#openIfRequestedAfterNavigation();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  /**
   * Abre o minicart depois do redirect da página de inscrição.
   * A flag é consumida uma vez para não reabrir em reload ou navegação seguinte.
   */
  #openIfRequestedAfterNavigation() {
    if (!this.#consumeOpenCartRequest()) return;
    this.open();
  }

  #consumeOpenCartRequest() {
    let pending = false;

    try {
      pending = sessionStorage.getItem(OPEN_CART_DRAWER_SESSION_KEY) === '1';
      if (pending) sessionStorage.removeItem(OPEN_CART_DRAWER_SESSION_KEY);
    } catch (error) {}

    if (pending) return true;

    try {
      const url = new URL(window.location.href);
      if (url.searchParams.get('open_cart') !== '1') return false;

      url.searchParams.delete('open_cart');
      const nextUrl = `${url.pathname}${url.search}${url.hash}`;
      window.history.replaceState(window.history.state, '', nextUrl);
      return true;
    } catch (error) {
      return false;
    }
  }

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
